import { render, staticRenderFns } from "./NoticeTemplate.vue?vue&type=template&id=0109530f&scoped=true"
import script from "./NoticeTemplate.vue?vue&type=script&lang=js"
export * from "./NoticeTemplate.vue?vue&type=script&lang=js"
import style0 from "./NoticeTemplate.vue?vue&type=style&index=0&id=0109530f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0109530f",
  null
  
)

export default component.exports